import { post, search } from './rest';

const rootUrl = `${process.env.API_URL}/case`;

export default {
	// eslint-disable-next-line no-underscore-dangle
	get: id => search(`${rootUrl}/${id}`),
	create: () => post(rootUrl)
	// delete: id => del(`${rootUrl}/${id}`)
};
